import { baseApi } from "@/lib/axios";
import { SmartContract, TSmartContract } from "@/types";
import { CONTRACT_API } from "./url";

export function getContract(
  type: TSmartContract | string,
  chainId: string
): Promise<SmartContract | object> {
  return baseApi({
    url: CONTRACT_API.urlGetContract(type, chainId),
    method: "GET",
  });
}
